import React, { useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import classNames from "classnames";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import AddCashOverCounter from "./AddCashOverCounter";
import { handlePostRequest } from "../../services/PostTemplate";

function CashOverCounter({ getCashOverCounter }) {
    const [loading, setloading] = useState(false);
    const [loadingIcon, setloadingIcon] = useState("pi pi-save");
    const [displayModal, setDisplayModal] = useState(false);
    const [setPosition] = useState("center");
    const [cashOverData, setCashOverData] = useState("");
    const [cashOverRowData, setCashOverRowData] = useState("");

    const dialogFuncMap = {
        displayModal: setDisplayModal,
    };

    const onClick = (name, position) => {
        dialogFuncMap[`${name}`](true);

        if (position) {
            setPosition(position);
        }
    };

    const onHide = (name) => {
        setDisplayModal(false);
    };
    const handleReset = () => {
        setCashOverData("");
        formik.resetForm();
    };

    const handleAddDetails = (data) => {
        onClick("displayModal");
        setCashOverRowData(data);
    };

    const actionTemplate = (rowData) => {
        return (
            <div className="Down__Btn">
                <Button disabled={loading} label="Add Details" className="Btn__Transparent" onClick={() => handleAddDetails(rowData)} />
            </div>
        );
    };
    const formik = useFormik({
        initialValues: {
            xpin: "",
        },
        validate: (data) => {
            let errors = {};

            return errors;
        },
        onSubmit: async (data) => {
            setloading(true);
            setloadingIcon("pi pi-spin pi-spinner");
            handlePostRequest(data, "zbizgateway/nonFin/verifyCoCXpin").then((res) => {
                setCashOverData(res?.data);
            });
            setloading(false);
            setloadingIcon("pi pi-save");
        },
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    return (
        <>
            <div className="card Card__Round">
                <div className="Form__Header">
                    <h1>Cash Over Counter</h1>
                </div>
                <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2">
                    <div className="p-fluid p-formgrid p-grid">
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field">
                                <label htmlFor="xpin" className={classNames({ "p-error": isFormFieldValid("xpin") }, "Label__Text")}>
                                    XPin
                                </label>
                                <InputText
                                    id="xpin"
                                    placeholder="XPin"
                                    name="xpin"
                                    value={formik.values.xpin}
                                    onChange={(e) => {
                                        formik.handleChange(e);
                                    }}
                                    className={classNames({ "p-invalid": isFormFieldValid("xpin") }, "Input__Round")}
                                />

                                {getFormErrorMessage("xpin")}
                            </div>
                        </div>
                    </div>
                    <div className="Down__Btn">
                        <Button disabled={loading} label="Reset" onClick={handleReset} className="Btn__Transparent" />
                        <Button disabled={loading} label="Search" className="Btn__Dark" />
                    </div>
                </form>
            </div>
            <Dialog visible={displayModal} style={{ width: "50vw" }} onHide={() => onHide("displayModal")}>
                <AddCashOverCounter cashOverRowData={cashOverRowData} onHide={onHide} />
            </Dialog>
            <div className="card p-datatable-sm">
                <DataTable header="" loading={loading} paginator rows={6} value={cashOverData} emptyMessage="No data found.">
                    <Column field="benName" header="Beneficiary Name" />
                    <Column field="benAddress" header="Beneficiary Address" />

                    <Column field="mobileNo" header="Contact Number" />
                    <Column field="docType" header="Document Type" />
                    <Column field="remitterName" header="Remitter Name" />
                    <Column field="transAmount" header="Amount" />
                    <Column field="transdate" header="Date" />
                    <Column body={actionTemplate} />
                </DataTable>
            </div>
            <br />
        </>
    );
}

export default CashOverCounter;
